import { put, takeLatest } from 'redux-saga/effects';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/inventoryTypes';
import { FetchDoctorsRequestPayload, FetchDoctorsResponsePayload } from '../../../shared/models/inventory.model';
import { DEPARTMENT_INPATIENT, INCLUSION_TYPE_INPATIENT, INVENTORY_FETCH_DOCTORS } from '../../../shared/constants/urlEndPoints';
import { error } from '../../../utils/utility';
import { doctorsImages, fetchIPDepartmentMasterData, fetchIPInclusionMasterData, saveDoctorsList } from '../../actions/inventoryAction';
import { FetchFileByteRequest, FetchFileByteResponse } from '../../../shared/models/file.profile.model';
import { FETCH_FILE_BYTES, FILE_FETCH_ERROR, INVENTROY_CONSTANTS } from '../../../shared/constants/commonConstants';
import _ from 'lodash';
import { SearchLookUpResponse } from '../../../shared/models/lookUp.model';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';

function* fetchDoctorsSaga({ payload }: any): Generator {
  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${INVENTORY_FETCH_DOCTORS}`;
  const requestPayload: FetchDoctorsRequestPayload = {
    pageNumber: 1,
    pageSize: 300,
    doctorByProfileId: true,
    fetchInActiveRecord: true,
    profileIds: [ApplicationDetail.instance.getProfileId()],
  };
  try {
    const response: any = yield SendRequest.instance.post<FetchDoctorsRequestPayload,
      FetchDoctorsResponsePayload>(url, (payload && !_.isEmpty(payload)) ? payload : requestPayload);
    if (response.isSuccess && response.doctorDetails && response.doctorDetails.length > 0) {
      yield put(saveDoctorsList(response.doctorDetails));
    } else if (response.errorMessage) {
      if (payload && !_.isEmpty(payload)) {
        error(INVENTROY_CONSTANTS.noDataFoundForFilter);
      } else {
        error(response.errorMessage);
      }
      yield put(saveDoctorsList({ error: response.errorMessage }));
    } else {
      error('Unable to fetch doctors list, please try again');
    }
  } catch (e) {
    error('Something went wrong, please try again');
  }
}
function* fetchDoctorsImagesSaga({ payload }: any): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${FETCH_FILE_BYTES}`;
  try {
    const response: any = yield SendRequest.instance.post<FetchFileByteRequest,
      FetchFileByteResponse>(url, payload);
    if (response && response.isSuccess && response.fileDetails && response.fileDetails.length > 0) {
      yield put(doctorsImages(response.fileDetails));
    } else {
      error('Doctors images not found, please upload image.');
    }
    return;
  } catch (e) {
    error(FILE_FETCH_ERROR);
  }
}

function* fetchIPInclusionMasterSaga(): Generator {
  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${INCLUSION_TYPE_INPATIENT}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchIPInclusionMasterData(response.lookUpData));
    } else {
      error('Inclusion master not found.');
    }
    return;
  } catch (e) {
    error(FILE_FETCH_ERROR);
  }
}
function* fetchIPDepartmentMasterSaga(): Generator {

  const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${DEPARTMENT_INPATIENT}`;
  try {
    const response: any = yield SendRequest.instance.get<
      SearchLookUpResponse>(url);
    if (response && response.isSuccess && response.lookUpData && response.lookUpData.length > 0) {
      yield put(fetchIPDepartmentMasterData(response.lookUpData));
    } else {
      error('Departments not found.');
    }
    return;
  } catch (e) {
    error(FILE_FETCH_ERROR);
  }
}

function* fetchFileBytes({
  payload: { applicationId, fileIdentifiers,  onSuccess }}: any): Generator {
  const url = `${process.env.REACT_APP_BASE_URL}${FETCH_FILE_BYTES}`;
  const payload = {
    applicationId,
    fileIdentifiers,
  };
  try {
    const response: any = yield SendRequest.instance.post<FetchFileByteRequest,
      FetchFileByteResponse>(url, payload);
    if (response && response.isSuccess) {
      onSuccess(response);
    } else {
      error(FILE_FETCH_ERROR);
    }
    return;
  } catch (e) {
    error(FILE_FETCH_ERROR);
  }
}
export function* watchHospitalAction(): any {
  yield takeLatest(actionTypes.FETCH_DOCTORS_LIST, fetchDoctorsSaga);
  yield takeLatest(actionTypes.FETCH_DOCTORS_IMAGES, fetchDoctorsImagesSaga);
  yield takeLatest(actionTypes.FETCH_IP_INCLUSION_MASTER, fetchIPInclusionMasterSaga);
  yield takeLatest(actionTypes.FETCH_IP_DEPARTMENT_MASTER, fetchIPDepartmentMasterSaga);
  yield takeLatest(actionTypes.FETCH_FILE_BYTES_DATA, fetchFileBytes);
}

export default watchHospitalAction;
